export default {
	sec_10: {
		title: {
			one: '플랫폼 및 ',
			two: '기능',
		},
		desc: {
			one: '기업관리에 최적화.',
			two: '오로지 기업에 맞추어져 있습니다.',
		},
		btn: {
			one: '회원가입하기',
			two: '앱 다운로드',
		},
	},
	sec_05: {
		title: {
			one: '가맹점 관리에서부터 ',
			two: '정확한 정산까지',
		},
		desc: {
			one: '기업에 최적화된 플랫폼을 만나보세요.',
		},
	},
	sec_11: {
		one: {
			title: {
				one: '직관적이고 심플합니다.',
			},
			desc: {
				one: '기업에 관해서는 최대한 심플하게',
			},
		},
		two: {
			title: {
				one: '배우지 않아도',
				two: '바로 사용 가능하게',
			},
			desc: {
				one: '플랫폼과 기능을 최대한 심플하게.',
				two: '그래서 관리자가 쉽게 사용 가능합니다.',
			},
		},
	},
};
